import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Margin } from 'styled-components-spacing';
import { Container } from 'components';
import View from 'containers/app/MaList/View/View';
import { MEMBERSHIP_STATUS } from 'helpers';
import { HonoraryNote } from './MyHonoraryMa.styled';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.user.honoraryMa',
    url: '/user/my-honorary-ma',
  },
];

/**
 * The association the user is an Honorary Fellow of.
 *
 * It reuses the public association page rather than the "My MA" one, because that is what this
 * is: somebody else's Member Association that the user holds an honorary affiliation with. The
 * note above it says so, so the page is never read as a second membership.
 */
const MyHonoraryMa = ({ honoraryMa, honoraryStatus, history }) => {
  const { t } = useTranslation();

  if (!honoraryMa || !honoraryMa.id) {
    history.push('/user');

    return null;
  }

  return (
    <>
      <Container>
        <Margin top={{ xs: 16 }}>
          <HonoraryNote>
            <strong>
              {honoraryStatus === MEMBERSHIP_STATUS.YES
                ? t('page.user.membership.honoraryOf', { name: honoraryMa.name })
                : t('page.user.membership.honoraryWaitingApproval', { org: 'MA' })}
            </strong>
            <p>{t('page.user.membership.honoraryNote')}</p>
          </HonoraryNote>
        </Margin>
      </Container>
      <View breadcrumbs={breadcrumbs} history={history} associationId={honoraryMa.id} />
    </>
  );
};

MyHonoraryMa.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  honoraryMa: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }),
  honoraryStatus: PropTypes.string,
};

MyHonoraryMa.defaultProps = {
  honoraryMa: null,
  honoraryStatus: null,
};

const mapStateToProps = ({
  user: {
    user: { honoraryMemberAssociation, honoraryMemberAssociationPeople },
  },
}) => ({
  honoraryMa: honoraryMemberAssociation,
  honoraryStatus: honoraryMemberAssociationPeople && honoraryMemberAssociationPeople.status,
});

export default connect(mapStateToProps, null)(MyHonoraryMa);
